import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Grid from "@mui/material/Grid";
import BSInput from "../../../common/js/components/BSInput";
import BSSelect from "../../../common/js/components/BSSelect";
import { use_type_options } from "../utils/constants";

const OtherForm = (props) => {
    const handleAttributeUpdate = (event) => {
        props.onChange(event.target.id, event.target.value);
    };

    const { data, errors, disableInputs, context } = props;

    return (
        <div>
            <Grid
                container
                spacing={8}
                sx={{
                    alignItems: "flex-start",
                }}
            >
                <Grid size={{ xs: 6 }}>
                    <BSInput
                        id="sfAvail"
                        label="OTHER SF AVAILABLE"
                        placeholder="Enter SF"
                        errorText="ex. 98101"
                        error={errors.sfAvail}
                        value={data.sfAvail}
                        onChange={handleAttributeUpdate}
                        disabled={disableInputs}
                    />
                </Grid>
                <Grid size={{ xs: 6 }}>
                    <BSInput
                        id="largestContigSf"
                        label="OTHER CONTIGUOUS SF AVAILABLE"
                        placeholder="Enter SF"
                        errorText="ex. 98101"
                        error={errors.largestContigSf}
                        value={data.largestContigSf}
                        onChange={handleAttributeUpdate}
                        disabled={disableInputs}
                    />
                </Grid>
            </Grid>
            <Grid
                container
                spacing={8}
                sx={{
                    alignItems: "flex-start",
                }}
            >
                <Grid size={{ xs: 6 }}>
                    {context === "property" && (
                        <BSInput
                            id="suite"
                            label="OTHER SUITE NUMBER"
                            placeholder="Enter number"
                            error={errors.suite}
                            value={data.suite}
                            onChange={handleAttributeUpdate}
                            disabled={disableInputs}
                        />
                    )}
                </Grid>
                {context === "listing" && (
                    <div>
                        <Grid size={{ xs: 6 }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={data.divisibleFlg ? true : false}
                                            onChange={(e, checked) => props.onChange(e.target.value, checked)}
                                            value="divisibleFlg"
                                            disabled={disableInputs === true}
                                            color="primary"
                                        />
                                    }
                                    label="Office Space Divisible"
                                    style={{ marginBottom: "10px" }}
                                />
                            </FormGroup>
                        </Grid>
                    </div>
                )}
            </Grid>
            {context === "listing" && (
                <div>
                    <Grid
                        container
                        spacing={8}
                        sx={{
                            alignItems: "flex-start",
                        }}
                    >
                        <Grid size={{ xs: 6 }}>
                            <BSInput
                                id="secondarySfAvailable"
                                label="SECONDARY SF AVAILABLE"
                                errorText="ex. 98101"
                                value={data.secondarySfAvailable}
                                error={errors.secondarySfAvailable}
                                onChange={handleAttributeUpdate}
                                placeholder="Enter SF"
                                disabled={disableInputs}
                            />
                        </Grid>
                        <Grid size={{ xs: 6 }}>
                            <BSSelect
                                id="secondarySfType"
                                label="SECONDARY SF TYPE"
                                value={data.secondarySfType}
                                error={errors.secondarySfType}
                                onChange={handleAttributeUpdate}
                                disabled={disableInputs}
                                options={use_type_options}
                            />
                        </Grid>
                    </Grid>
                </div>
            )}
        </div>
    );
};

export default OtherForm;
